import api from "./api";

const route = "/video_types";

const VideoTypesService = {
  getVideoTypes: () => api.get(route),
};

export default VideoTypesService;
